import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/node/app/rdp-employee/layouts/default.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/home/node/app/rdp-employee/layouts/public.vue").then(m => m.default || m))
}